import { Drawer, Stack } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import JudgeGPTMainContainer from "../../components/JudgeGPT";
import JudgeGPTSidebar from "../../components/layout/JudgeGPTSidebar";
import { showInsufficientCreditsModal } from "../../actions/creditActions";
import { deductCredits } from "../../utils/HelperFunction/deductCredits";
import { judgeGptGetInitInfoApi, judgeGptGetChatHistoryApi } from "../../services/api/judgeGptApi";
export const JudgeGPTParent = () => {
  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const [isLoading, setIsLoading] = useState(true);
  const [loadingDocx, setLoadingDocx] = useState(false);
  const [selectedChat, setSelectedChat] = useState(null);
  const [chatTitlesList, setChatTitlesList] = useState([]);
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [metaData, setMetaData] = useState({});
  const [docFileUrl, setDocFileUrl] = useState("");
  const [fileType, setFileType] = useState("");
  const [file, setFile] = useState(null);
  const [previewDocument, setPreviewDocument] = useState(null);
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.credit.userId);
  const credits = useSelector((state) => state.credit.credits); // Get credits from Redux store
  const abortControllerRef = useRef(null);
  const toggleSidebarVisibility = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };
  // Fetch initial chat data
  useEffect(() => {
    const fetchChatInitInfo = async () => {
      try {
        const response = await judgeGptGetInitInfoApi(userInfo?._id);

        if (response.status !== 200) {
          throw new Error("Failed to fetch chat data");
        }

        const data = response.data;
        setChatTitlesList(data);
      } catch (err) {
        console.error("Error fetching chat data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    if (userInfo?._id) {
      fetchChatInitInfo();
    }
  }, [userInfo?._id]);

  // Usage when selecting a chat
  const handleChatSelect = (doc_id) => {
    setPreviewDocument(null); // Reset preview document
    setSelectedChat(doc_id);
    handleReadDocument(doc_id);
  };

  // Function to handle document reading
  const handleReadDocument = async (doc_id) => {
    setLoadingDocx(true);

    // Abort previous request if it exists
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Create a new AbortController
    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    // Reset state
    setDocFileUrl("");
    setFileUrl("");
    setFileType("");
    // setFile(null);

    try {
      // Define the fetch requests
      let creditsToDeduct = 1;
      if (credits <= 0 || credits <= creditsToDeduct) {
        dispatch(showInsufficientCreditsModal()); // Trigger modal if credits are insufficient
        return;
      }
      const getMetadataRequest = await judgeGptGetChatHistoryApi(userInfo?._id, doc_id);
      // Handle metadata response
      if (getMetadataRequest.status !== 200) {
        throw new Error(
          `Metadata fetch error! status: ${getMetadataRequest.status}`
        );
      }

      const metadata = getMetadataRequest.data;
      setMetaData(metadata);
      setLoadingDocx(false);
      // Deduct credits
      const deductionSuccess = deductCredits(
        {
          userId,
          creditsToDeduct: 1,
          event: "Get Previous Generated Judgment",
        },
        dispatch
      );

      if (!deductionSuccess) {
        console.warn(
          "Failed to deduct credits. Ensure retry or user notification."
        );
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Request was aborted");
      } else {
        console.error("Error:", error);
        setFileUrl("");
        setDocFileUrl("");
        setFileType("");
        setLoadingDocx(false);
      }
    } finally {
      if (abortControllerRef.current === abortController) {
        abortControllerRef.current = null;
      }
    }
  };

  return (
    <Stack direction="row" height="calc(100vh - 50px)" width="100%">
      {isMobileView ? (
        <Drawer
          anchor="left"
          open={isSidebarVisible}
          ModalProps={{
            keepMounted: true,
          }}
          onClose={toggleSidebarVisibility}
        >
          <JudgeGPTSidebar
            closeSidebar={toggleSidebarVisibility}
            isLoading={isLoading}
            chatTitlesList={chatTitlesList}
            setChatTitlesList={setChatTitlesList}
            selectedChat={selectedChat}
            setSelectedChat={setSelectedChat}
            handleChatSelect={handleChatSelect}
            setDocFileUrl={setDocFileUrl}
            setFileType={setFileType}
            setFileUrl={setFileUrl}
            setFile={setFile}
            setMetaData={setMetaData}
            previewOpen={previewOpen}
            setPreviewOpen={setPreviewOpen}
            previewDocument={previewDocument}
            setPreviewDocument={setPreviewDocument}
          />
        </Drawer>
      ) : (
        !isMobileView && (
          <JudgeGPTSidebar
            isLoading={isLoading}
            chatTitlesList={chatTitlesList}
            setChatTitlesList={setChatTitlesList}
            selectedChat={selectedChat}
            setSelectedChat={setSelectedChat}
            handleChatSelect={handleChatSelect}
            setDocFileUrl={setDocFileUrl}
            setFileType={setFileType}
            setFileUrl={setFileUrl}
            setFile={setFile}
            setMetaData={setMetaData}
            previewOpen={previewOpen}
            setPreviewOpen={setPreviewOpen}
            previewDocument={previewDocument}
            setPreviewDocument={setPreviewDocument}
          />
        )
      )}

      <JudgeGPTMainContainer
        toggleSidebar={toggleSidebarVisibility}
        chatTitlesList={chatTitlesList}
        setChatTitlesList={setChatTitlesList}
        fileType={fileType}
        fileUrl={fileUrl}
        docFileUrl={docFileUrl}
        setDocFileUrl={setDocFileUrl}
        setFileType={setFileType}
        setFileUrl={setFileUrl}
        file={file}
        setFile={setFile}
        loadingDocx={loadingDocx}
        setSelectedChat={setSelectedChat}
        metaData={metaData}
        setMetaData={setMetaData}
        selectedChat={selectedChat}
        previewOpen={previewOpen}
        setPreviewOpen={setPreviewOpen}
        previewDocument={previewDocument}
        setPreviewDocument={setPreviewDocument}
      />
    </Stack>
  );
};
